var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinanceCalculator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 47 47"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M46.11 23.717V41.89c0 2.294-1.457 4.097-3.658 4.528q-.47.087-.946.082H13.374A12.845 12.845 0 0 1 .705 35.996c-1.256-6.725 3.117-13.341 9.803-14.828.263-.06.347-.15.346-.425q-.015-7.607 0-15.216c0-1.946 1.025-3.568 2.751-4.24a5 5 0 0 1 1.754-.35A6540 6540 0 0 1 41.585.923c2.572 0 4.524 1.984 4.527 4.588q.005 9.102-.003 18.206m-21.387 4.075c.037-.122.059-.183.075-.246.332-1.274 1.34-2.06 2.654-2.066.735 0 1.468-.014 2.202 0 1.254.03 2.388.975 2.51 2.219.098.99.102 1.988.011 2.98a2.5 2.5 0 0 1-2.389 2.267c-1.212.046-2.451.227-3.68-.262v2.658c.394-.085.81-.224 1.226-.246.765-.041 1.533-.023 2.3-.01 1.265.023 2.412.975 2.538 2.229.101.969.107 1.945.018 2.915-.131 1.411-1.276 2.347-2.699 2.352h-2.103a2.665 2.665 0 0 1-2.649-2.56v-.323a17.6 17.6 0 0 1-2.091 2.78 18 18 0 0 1-2.608 2.205h21.52c1.577 0 2.724-1.129 2.725-2.704V5.435c0-1.56-1.146-2.687-2.702-2.687H15.42c-1.633 0-2.76 1.13-2.76 2.769V20.83l2.457.101c0-.789-.007-1.554 0-2.32.021-1.593 1.157-2.725 2.745-2.737.756 0 1.512-.02 2.267.013 1.251.055 2.344 1.043 2.446 2.287.07.95.07 1.904 0 2.853-.064.956-.63 1.631-1.47 2.075-.09.048-.184.092-.307.153a13.15 13.15 0 0 1 3.924 4.54zm-.387 5.905a10.995 10.995 0 0 0-11.125-11.02c-6.098.03-10.992 5.112-10.896 11.184.093 5.944 5.012 10.89 11.16 10.838 5.937-.057 10.877-5.03 10.861-11.002m6.064 5.158v-1.051c0-.534-.328-.89-.869-.9a46 46 0 0 0-2.165.011.825.825 0 0 0-.83.841 52 52 0 0 0 0 2.167c.009.443.325.816.734.83.79.028 1.578.035 2.367.008.464-.014.763-.385.769-.857q-.005-.53-.006-1.055zM18.865 21.548h1.083a.827.827 0 0 0 .853-.847q.014-1.066 0-2.133a.846.846 0 0 0-.83-.883q-1.1-.03-2.198 0a.85.85 0 0 0-.843.875 68 68 0 0 0 0 2.133.846.846 0 0 0 .883.856q.527 0 1.052-.001m11.535 7.68V28.21c0-.54-.32-.91-.849-.92a41 41 0 0 0-2.166.009.84.84 0 0 0-.85.861 48 48 0 0 0 0 2.134.85.85 0 0 0 .881.866 61 61 0 0 0 2.134 0c.52-.01.848-.362.852-.88q0-.526-.002-1.053"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M28.45 13.773H16.29c-.884 0-1.183-.297-1.183-1.183V5.985c0-.825.31-1.135 1.126-1.135H40.91a.887.887 0 0 1 .91.814q.014.163.008.327c0 2.147-.027 4.295.012 6.442.018 1.064-.417 1.363-1.37 1.35-2.541-.03-5.082-.008-7.625-.008zm-11.511-1.84h23.05V6.659H16.94z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M41.838 34.026v5.685c0 1.749-1.127 2.873-2.88 2.873h-2.004a2.64 2.64 0 0 1-2.612-2.598q-.024-5.947 0-11.896a2.63 2.63 0 0 1 2.601-2.602c.735-.015 1.469-.01 2.202 0a2.66 2.66 0 0 1 2.689 2.688c.014 1.95.004 3.9.004 5.85m-1.821.027V28.27c0-.637-.337-.98-.966-.986a95 95 0 0 0-1.94 0c-.618 0-.972.363-.972.99v11.501c0 .658.342.993.992 1h1.808c.778 0 1.078-.3 1.08-1.07z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M24.727 19.606v-.985c.011-1.591 1.14-2.73 2.726-2.746a99 99 0 0 1 2.036 0c1.446.014 2.562.95 2.702 2.385.088.915.088 1.837 0 2.753a2.51 2.51 0 0 1-2.336 2.324c-.959.082-1.923.075-2.88-.021-1.238-.122-2.176-1.217-2.235-2.461-.019-.415 0-.832 0-1.249zm3.718 1.942h1.052c.563 0 .9-.335.903-.89V18.59c0-.532-.338-.9-.865-.908a58 58 0 0 0-2.133 0 .84.84 0 0 0-.863.85c-.017.72-.02 1.446 0 2.165.012.51.383.843.894.847.334.006.673.004 1.012.004"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  d: "M38.092 15.874h1.052c1.401.025 2.525.977 2.657 2.366.083.917.083 1.838 0 2.754a2.52 2.52 0 0 1-2.322 2.335c-.959.086-1.924.082-2.883-.013-1.284-.131-2.234-1.254-2.26-2.541a63 63 0 0 1 0-2.3 2.644 2.644 0 0 1 2.54-2.596c.405-.018.81 0 1.215 0zm-.038 5.674h1.052c.544 0 .898-.325.907-.86q.016-1.065 0-2.132a.844.844 0 0 0-.84-.873 45 45 0 0 0-2.198 0 .826.826 0 0 0-.823.82 38 38 0 0 0-.008 2.198c.013.517.382.842.894.846.338.003.681 0 1.016 0"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  d: "M8.786 31.557c.087.346.176.691.275 1.078-.3 0-.55-.005-.805-.01-.573.02-.949.387-.94.92.007.51.395.874.944.882.353.01.704-.014 1.052.01a.36.36 0 0 1 .254.2q.16.515.263 1.045a2.84 2.84 0 0 1-1.277 2.946q-.31.184-.591.411a1.1 1.1 0 0 0-.293.386.87.87 0 0 0 .252 1.012.89.89 0 0 0 1.042.09c.246-.141.463-.332.726-.444 1.042-.45 2.032-.33 2.94.352 1.783 1.347 4.013 1.406 5.734.132.198-.148.352-.348.447-.577a.85.85 0 0 0-.351-.98c-.34-.23-.723-.21-1.1.061-1.058.76-2.329.85-3.313.147-.82-.59-1.674-1.063-2.63-1.17.098-.608.257-1.19.263-1.791s-.135-1.205-.215-1.824h.657c1.292 0 2.586.007 3.878 0a.89.89 0 0 0 .903-.752.88.88 0 0 0-.555-.974 1.6 1.6 0 0 0-.514-.068c-1.534-.007-3.067-.01-4.6 0-.225.001-.33-.057-.38-.29-.095-.46-.235-.91-.346-1.366-.368-1.516.545-3.087 2.011-3.46 1.801-.46 3.464.799 3.595 2.731.042.604.415.98.942.955s.873-.434.855-1.038a4.68 4.68 0 0 0-5.94-4.37c-2.432.682-3.824 3.212-3.183 5.756"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 47.166,
  x2: 13.257,
  y1: 37.813,
  y2: 24.13,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 41.867,
  x2: 19.744,
  y1: 12.735,
  y2: 7.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 41.869,
  x2: 29.626,
  y1: 34.988,
  y2: 33.703,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 42.221,
  x2: 19.166,
  y1: 25.098,
  y2: 23.519,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 40.808,
  x2: 31.152,
  y1: 21.565,
  y2: 18.651,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 27.385,
  x2: 12.746,
  y1: 40.286,
  y2: 36.553,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311C77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8C32BE"
})))));
export default SvgFinanceCalculator;